/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThresholdActionConfigurationModel {
    getFixupPrototypeFunction() { return ThresholdActionConfigurationModel.fixupPrototype; }

    static newInstance(model: Partial<ThresholdActionConfigurationModel>): ThresholdActionConfigurationModel {
        let obj = Object.assign(new ThresholdActionConfigurationModel(), model);
        ThresholdActionConfigurationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThresholdActionConfigurationModel>): ThresholdActionConfigurationModel {
        if (!model) return null;
        return ThresholdActionConfigurationModel.newInstance(<ThresholdActionConfigurationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThresholdActionConfigurationModel) {
        if (!obj) return;

        models.ThresholdActionConfigurationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThresholdActionConfigurationModel): boolean {
        Object.setPrototypeOf(obj, ThresholdActionConfigurationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * action configuration
     */
    action_configuration: Array<string>;

    /**
     * action uri
     */
    action_uri: Array<string>;

}
